/**
 * 🕵️ TAXONOMY TRAWLER (AUDITOR)
 * Location: src/registered/site-admin/components/Workflow-esg/controllers/TaxonomyTrawlerController.js
 */
export const TaxonomyTrawlerController = {
    generateAuditSummary: (xbrlRelationships, esgTree) => {
        console.log("🟢 [TRAWLER:START] Processing 4-Box Summary...");
        
        const concepts = esgTree?.concepts || {};
        const conceptKeys = Object.keys(concepts);
        const standards = [...new Set(conceptKeys.map(key => key.split(':')[0].replace('esrs', 'ESRS')))];
        
        // 🎯 SEARCH INDEX CHECK: Finding BP-1 and salient items
        const refsCount = xbrlRelationships?.searchIndex?.filter(item => item.legalRef).length || 0;

        const output = {
            levels: ["ROOT", "CHAPTER", "DISCLOSURE", "DATAPOINT"],
            idsCount: conceptKeys.length, // 5208
            standards: standards,
            referencesCount: refsCount
        };

        console.log("📤 [TRAWLER:RETURN] Summary Object:", output);
        return output;
    },

    generatePhysicalStats: (xbrlRelationships) => {
        console.log("🟢 [TRAWLER:START] Processing Physical Inventory...");
        
        const stats = [
            { 
                ColumnName: "Presentation (Hierarchy)", 
                UniqueValueCount: xbrlRelationships?.presentation?.length || 0, 
                TotalOccurrences: xbrlRelationships?.stats?.totalConcepts || 0, // 5208
                MaxLength: 250 
            },
            { 
                ColumnName: "Definition (Dimensions)", 
                UniqueValueCount: "N/A", 
                TotalOccurrences: xbrlRelationships?.definition?.length || 0, // 15502
                MaxLength: 180 
            },
            { 
                ColumnName: "Calculation (Weights)", 
                UniqueValueCount: "N/A", 
                TotalOccurrences: xbrlRelationships?.calculation?.length || 0, // 52
                MaxLength: 50 
            }
        ];
        
        console.log("📤 [TRAWLER:RETURN] Physical Stats Array:", stats);
        return stats;
    }
};